import { uniqueArrayByKey } from "../array";
import type { Nullable, StaticPlan } from "../types";

export function getPlanStaticStats(plans: StaticPlan[], ownOrgId: Nullable<string>) {
	const stats = {
		crews: 0,
		ownCrews: 0,
		subCrews: 0,
		projects: 0,
		tickets: 0,
	};

	if (!ownOrgId) return stats;

	for (const plan of plans) {
		const projectsFlat = plan.crews.flatMap((crew) => crew.projects);
		const ticketsFlat = projectsFlat.flatMap((project) => project.tickets);
		stats.crews += plan.crews.length;
		stats.ownCrews += plan.crews.filter((crew) => crew.orgId === ownOrgId).length;
		stats.ownCrews += plan.crews.filter((crew) => crew.orgId !== ownOrgId).length;
		stats.projects += uniqueArrayByKey(projectsFlat, "id").length;
		stats.tickets += uniqueArrayByKey(ticketsFlat, "id").length;
	}

	return stats;
}

export type PlanStaticStats = ReturnType<typeof getPlanStaticStats>;
